<template>
    <div class="ajuda">
        <el-row class="u-mt-10 u-mb-20">
            <el-col :xs="24" :sm="16" :md="16">
                <el-input v-model="filtro['text']" placeholder="Pesquisar por ajuda..." @keyup.native.enter="loadingAjuda"></el-input>
            </el-col>
            <el-col :xs="24" :sm="8" :md="8" class="u-text-right" v-if="$store.state.user.tipo > 3 && $store.state.user.tipo <= 8">
                <router-link to="/admin/ajuda/cadastro" class="btn-new-register">
                    <el-button type="primary">NOVA AJUDA</el-button>
                </router-link>
            </el-col>
        </el-row>
        
        <ul style="padding-left: 0px;">
            <li v-for="item in items" :key="item.id" style="padding: 15px 10px; border-top: 1px solid #ccc; cursor: pointer;">
                <router-link :to="'/admin/ajuda/info/' + item.id" style="color: #000000de;">
                    <div style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden;">
                        <b style="display: block; text-transform: uppercase;">{{ item.titulo }}</b>
                        <i>{{ item.descricao.replace(regex, "") }}</i>
                    </div>
                </router-link>
            </li>
        </ul>        
    </div>
</template>
<script>

export default {
    data: () => ({
        regex: /<\/?[^>]+(>|$)/g,
        statusList: false,
        filtro: {
            text: ''
        },
        items: [ ]
    }),
    mounted () {
      this.loadingAjuda()
    },
    methods: {
        loadingAjuda(){

            this.statusList = false;
            this.items = [];

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/ajuda/getAjudas`, this.filtro, this.$store.getters.getHeaderAuth).then(response => {

                this.items = response.data;
                this.statusList = true;

            }).catch((error) => { this.$store.commit('throwException', error); });

        }
    },
    components:{  }
}
</script>